import React, { useEffect, useState } from 'react';

function NumInput({ value, onChange }) {

    const [count, setCount] = useState(value || 1);


    useEffect(() => {
        setCount(value || 1);
    }, [value]); // Dependency array ensures this runs whenever value changes

    // Increment value
    const increment = () => {
        const newValue = count + 1;
        setCount(newValue);
        onChange(newValue);
    };

    // Decrement value, making sure it doesn't go below 0
    const decrement = () => {
        const newValue = count > 0 ? count - 1 : 0;
        setCount(newValue);
        onChange(newValue);
    };

    // Handle manual input change
    const handleInputChange = (e) => {
        let value = e.target.value;

        // If input is not a number or empty, set to 0; otherwise, set to parsed value
        const numValue = isNaN(parseInt(value, 10)) ? 0 : parseInt(value, 10);

        setCount(numValue);
        onChange(numValue);
    };

    return (
        <form className="max-w-xs mx-auto">
            <label htmlFor="small-input" className="font-poppins block mb-2 text-sm font-medium text-gray-300">
                Choose Seats
            </label>
            <div className="relative flex items-center max-w-[9rem]">
                {/* Decrement Button */}
                <button
                    onClick={decrement}
                    type="button"
                    id="decrement-button"
                    className="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none"
                >
                    <svg className="w-3 h-3 text-gray-900 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 2">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h16" />
                    </svg>
                </button>

                {/* Input Field */}
                <input
                    type="number"
                    onChange={handleInputChange}
                    className="bg-gray-50 border-x-0 border-gray-300 h-11 text-center text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full py-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="999"
                    value={count} // Controlled input field
                    required
                />

                {/* Increment Button */}
                <button
                    onClick={increment}
                    type="button"
                    id="increment-button"
                    className="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none"
                >
                    <svg className="w-3 h-3 text-gray-900 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 1v16M1 9h16" />
                    </svg>
                </button>
            </div>
        </form>
    );
}

export default NumInput;
